import { render, staticRenderFns } from "./OfferView2.vue?vue&type=template&id=5ee5477b&scoped=true"
import script from "./OfferView2.vue?vue&type=script&lang=js"
export * from "./OfferView2.vue?vue&type=script&lang=js"
import style0 from "./OfferView2.vue?vue&type=style&index=0&id=5ee5477b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ee5477b",
  null
  
)

export default component.exports